import LogRocket from 'logrocket';

import { IS_PRODUCTION_ENVIRONMENT } from '@/constants';
import mock from '@/mocks/mockLogRocket';

const original = LogRocket;

const instance: typeof LogRocket | typeof mock = IS_PRODUCTION_ENVIRONMENT ? original : mock;

export default instance;
